// extracted by mini-css-extract-plugin
export default {"fixedHeader":"styles_fixedHeader__FJ9mP"};